import React, {useEffect, useState} from "react";
import classNames from "classnames/bind";
import {hybrid} from "api/hybrid";

import {Screen} from "../../components/Screen";
import {useStateManager} from "../../utils/useStateManager";
import {emailFormValidation} from "../Registration/validation";
import {Field, Form} from "react-final-form";
import {FormValues} from "../Registration";
import {Input} from "../../components/Input";
import {InputPhone} from "../../components/InputPhone";

import styles from "./EmailScreen.module.css";

const cx = classNames.bind(styles);

type Props = {
  onBack: () => void;
};

export const EmailScreen: React.FC<Props> = (props) => {
  const {
    isLoading,
    patient,
    template,
    registrationData,
    setIsLoading,
    isCountDownWasShown,
    setIsCountDownWasShown
  } = useStateManager();

  const [tippyMessage, setTippyMessage] = useState<string>("");
  const [time, setTime] = useState(isCountDownWasShown ? 30 : 0)

  useEffect(() => {
    if (tippyMessage) {
      const errorMessageTimer = setTimeout(() => {
        setTippyMessage("")
      }, 5000);

      return () => {
        clearTimeout(errorMessageTimer);
      }
    }
  }, [tippyMessage]);

  useEffect(() => {
    if (time > 0) {
      !isCountDownWasShown && setIsCountDownWasShown(true)
      const countdownTimer = setTimeout(() => {
        setTime(prev => prev - 1)
      }, 1000)

      return () => {
        clearTimeout(countdownTimer);
      }
    }
  }, [time]);

  const handleSubmit = async ({...formValues}: FormValues) => {
    setIsLoading(true)

    try {
      if (registrationData) {
        await hybrid.post(
          `/${process.env.REACT_APP_API_KEY}t162r/json/v2`,
          {
            data: {
              custom_email: formValues.custom_email_for_pdf,
              custom_patientkey: registrationData.patient.key,
              custom_исходник: template,
              custom_фио_пациента: registrationData.patient.fields.custom_ио
            },
          },
          {
            responseType: "blob",
          }
        );
        setTippyMessage("Ваше заключение успешно отправлено на указанную почту")
        setTime(30)
      }
    } catch (error) {
      setTippyMessage("Возникла проблема в отправке, повторите позже")
    }

    setIsLoading(false)
  }

  type FormFieldProps = React.ComponentProps<typeof Input> & {
    name: keyof FormValues;
  };

  const FormField: React.FC<FormFieldProps> = (props) => (
    <Field name={props.name}>
      {({input, meta}) => (
        <Input
          {...input}
          label={props.label}
          required={props.required}
          mask={props.mask}
          error={meta.touched ? meta.error : undefined}
          disabled={time > 0 || isLoading || !!tippyMessage}
        />
      )}
    </Field>
  );

  return (
    <>
      {tippyMessage && (
        <div className={cx("notification")}>
          <span>{tippyMessage}</span>
        </div>
      )}
      <Form<FormValues>
        initialValues={
          {
            custom_email_for_pdf: patient?.custom_login || "",
          }
        }
        validate={emailFormValidation}
        validateOnMount
        onSubmit={handleSubmit}
      >
        {({handleSubmit, valid}) => {
          return (
            <Screen
              title="Полный отчет на почту"
              buttonTitle={time ? `Отправить повторно через 00:${time < 10 ? '0' + time : time}` : 'Отправить'}
              onSubmit={handleSubmit}
              onBack={isLoading ? null : props.onBack}
              isInvalid={!valid || time > 0 || !!tippyMessage}
              isLoading={isLoading}
            >
              <p className={cx("form-text")}>Укажите адрес электроннной почты, куда отправить заключение и
                рекомендацию</p>
              <div className={cx("form-body")}>
                <FormField
                  name="custom_email_for_pdf"
                  label={"Эл.почта"}
                  required={true}
                />
              </div>
            </Screen>
          );
        }}
      </Form>
    </>
  )
}